import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-safe-more",
  "use": "icon-safe-more-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-safe-more\">\r\n<path d=\"M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol